module.exports = __webpack_public_path__ + "2aaa6f1be965eb98de80e55286525ff6.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/search.png
// module id = 134
// module chunks = 0